import { RatePlanSwitcherProps } from "@/components/RatePlanSwitcher/RatePlanSwitcherProps.ts";
import { useRatePlanSwitcher } from "@/components/RatePlanSwitcher/useRatePlanSwitcher.ts";
import { RateRow } from "@/components/RateRow/RateRow.tsx";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

export const RatePlanSwitcher = ({ item }: RatePlanSwitcherProps) => {
  const { t } = useTranslation();
  const {
    sortedRates,
    firstRate,
    restRates,
    hasMore,
    isExpanded,
    reservationNights,
    selectedRateId,
    handleSelectRate,
    handleToggleOtherRates,
    isPaymentIncompatible,
  } = useRatePlanSwitcher(item);

  if (sortedRates?.length === 0) return null;

  return (
    <div className="c-rate-plan-switcher">
      <div className="c-rate-plan-switcher__rates">
        <RateRow
          ratePlan={firstRate}
          isSelected={firstRate.id === selectedRateId}
          reservationNights={reservationNights}
          onSelect={() => handleSelectRate(firstRate)}
          showRadio={hasMore}
          isLast={!hasMore}
          isPaymentIncompatible={isPaymentIncompatible(firstRate)}
          mode="switcher"
        />
        {hasMore && (
          <div className={`c-rate-plan-switcher__expand${isExpanded ? " is-expanded" : ""}`}>
            <div className="c-rate-plan-switcher__expand-inner">
              {restRates.map((rp, index) => (
                <RateRow
                  key={rp.id}
                  ratePlan={rp}
                  isSelected={rp.id === selectedRateId}
                  reservationNights={reservationNights}
                  onSelect={() => handleSelectRate(rp)}
                  showRadio
                  isLast={index === restRates.length - 1}
                  isPaymentIncompatible={isPaymentIncompatible(rp)}
                  mode="switcher"
                />
              ))}
            </div>
          </div>
        )}
      </div>
      {hasMore && (
        <button
          type="button"
          className={`c-rate-plan-switcher__toggle${isExpanded ? " is-expanded" : ""}`}
          onClick={handleToggleOtherRates}
        >
          <span className="c-rate-plan-switcher__toggle-label">{t("otherRates")}</span>
          <ChevronDown size={16} className="c-rate-plan-switcher__toggle-icon" />
        </button>
      )}
    </div>
  );
};
